import {Controller} from "@hotwired/stimulus";
import Debug from 'debug';

export const name = 'lazy-content';

const debug = Debug(`app:${name}`);

export default class extends Controller<HTMLDivElement> {

    static targets = ["content", "loading"]

    connect() {

    }

    animateContent = () => {
        const contentHeight = this.element.scrollHeight;
        this.element.style.height = `${contentHeight}px`;
        this.element.classList.remove('opacity-0')
        this.element.classList.add('opacity-100')
        debug('set height to', contentHeight);

        // Listen for the transition to finish
        this.element.addEventListener('transitionend', this.setHeightAuto, { once: true });
    }

    setHeightAuto = () => {
        debug('setting height to auto');
        // This removes the inline height, allowing the element to grow/shrink naturally
        this.element.style.height = 'auto';
    }


    disconnect() {
        this.element.style.removeProperty('height');
        this.element.removeEventListener('transitionend', this.setHeightAuto);
    }

    contentTargetConnected() {
        this.animateContent();
        this.animateContent = () => {};
    }

    loadingTargetConnected() {

    }

}